import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../authentication/AuthProvider";
import { routes } from "../routes/routes";
import { findCurrectPermission } from "../helpers/roles-and-permissions";
import { enums } from "../enums/Enums";

export function AdminAddEmployeeGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(enums.UserPermissionNames.ADMIN_ADD_EMPLOYEE) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function AdminEmployeeLimitGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(enums.UserPermissionNames.ADMIN_EMPLOYEE_LIMIT) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}
export function AdminAppovalDocumentPersonGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(
      enums.UserPermissionNames.ADMIN_APPROVAL_DOCUMENT_PERSON
    ) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function AdminRolesGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(enums.UserPermissionNames.ROLES_PERMISSIONS) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function EmployeeViewGourd() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(enums.UserPermissionNames.ROLES_PERMISSIONS) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}
